import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { ChatComponent } from './chat.component';
import { ChatIndexComponent } from './chatindex/chat-index.component';
import { JoinRegionComponent } from './join-region/join-region.component';
import { ChatBoxComponent } from './chat-box/chat-box.component';

const chatRoutes: Routes = [
    {
        path: 'chat',
        component: ChatComponent,
        children: [
            {
                path: '',
                component: ChatIndexComponent
            },
            {
                path: 'joinregion',
                component: JoinRegionComponent
            },
            {
                path: 'messages',
                component: ChatBoxComponent
            },
        ]
    }
];

export const chatRouting: ModuleWithProviders = RouterModule.forChild(chatRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat.routing.ts